// import { getLocaleTime } from '../../utils.js'
const fb = require('../../firebaseConfig.js')

export default {
    state: {
        computingMetric: {},
		computingMetricId: '',
		computingMetrics: [],
		computingMetricsPagination: { page: 1, pageSize: 10, lastVisible: null, showLoadMore: true },
        computingMetricTypes: []

    },
    getters: {
        computingMetric: (state) => {
			return state.computingMetric
		},
		computingMetricsPagination: (state) => {
			return state.computingMetricsPagination
		},
		computingMetrics: (state) => {
			return state.computingMetrics
		},
        computingMetricTypes: (state) => {
            return state.computingMetricTypes
        }
    },
    mutations: {
        setComputingMetrics(state, val) {
			state.computingMetrics = val
		},
		setComputingMetric(state, val) {
			state.computingMetric = val
		},
		setComputingMetricId(state, val) {
			state.computingMetricId = val
		},
		setComputingMetricsPagination(state, val) {
			state.computingMetricsPagination = val
		},
        setComputingMetricTypes(state, val) {
            console.log(val)
            state.computingMetricTypes = val
        }
    },
    actions: {
        updateComputingMetricsPagination({commit}, data) {
            commit('setComputingMetricsPagination', data)
        },
        async fetchComputingMetrics({commit, getters}) {
            let computingMetricsPagination = getters.computingMetricsPagination
            var query = fb.dxfFilesCollection.orderBy('timestamp', 'desc').limit(computingMetricsPagination.pageSize)

            if (computingMetricsPagination.lastVisible != null) {
                query = query.startAfter(computingMetricsPagination.lastVisible)
            }

            await query.onSnapshot(querySnapshot => {
                if (querySnapshot.empty) {
                    computingMetricsPagination.showLoadMore = false
                }

                let computingMetrics = (computingMetricsPagination.lastVisible != null && computingMetricsPagination.page != 1) ? getters.computingMetrics : [];
                computingMetricsPagination.lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];

                querySnapshot.forEach((computingMetric) => {
                    let computingMetricEdited = computingMetric.data()
                    computingMetricEdited.id = computingMetric.id
                    computingMetrics.push(computingMetricEdited)
                })

                if (computingMetricsPagination.page * computingMetricsPagination.pageSize > computingMetrics.length) {
                    computingMetricsPagination.showLoadMore = false
                    computingMetricsPagination.lastVisible = null
                }

                commit('setComputingMetricsPagination', computingMetricsPagination)
                commit('setComputingMetrics', computingMetrics)
            })
        },
        async fetchComputingMetric({commit}, { computingMetricId }) {
            await fb.dxfFilesCollection.doc(computingMetricId).get().then(res => {
                let computingMetric = res.data()
                computingMetric.id = computingMetricId

                computingMetric.data.forEach(record => {

                    if (computingMetric.type.type == 'enfierradura' || computingMetric.type.type == 'enfierraduralosas') {

                        if (record.error == undefined) {

                            var splittedLabel = ''
                            var fi = ''
                            var longitud = ''
                            var longitudSplitted = ''
                            var dist = ''
                            var fiSplitted = ''
                            var fiLabel = ''
                            var quantity = 0

                            if (record.type == undefined) {
                                record.label = record.label.replace(/\s+/g, ' ')

                                // F'=3%c12 L=200
                                // F'=%%c8a16|L=540
                                record.label = record.label.replaceAll('%%c', 'Φ')
                                record.label = record.label.replaceAll('%%C', 'Φ')

                                console.log(record.label)
                                record.label = record.label.trim();
                                if (record.label.startsWith('|')) {
                                    record.label = record.label.substring(1,record.label.length)
                                }
                                splittedLabel = record.label.split('|');
                                if (splittedLabel.length == 1) {
                                    splittedLabel = record.label.split(' ');
                                }


                                dist = 0;
                                quantity = 0;
                                fi = splittedLabel[0];
                                if (fi.length > 0) {
                                    longitud = splittedLabel[splittedLabel.length-1];
                                    if (longitud != undefined) {
                                        longitudSplitted = longitud.split('=');
                                        longitud = longitudSplitted[1];
                                    } else {
                                        longitud = 0
                                    }

                                    fiSplitted = fi.split('Φ')
                                    fi = fiSplitted[1]
                                    dist = fi.split('a')


                                    if (dist.length > 1) {
                                        fi = dist[0];
                                        dist = dist[1]
                                    } else {
                                        dist = ''
                                    }

                                    fiSplitted = fiSplitted[0].split('=');

                                    if (isNaN(fiSplitted[fiSplitted.length-1])) {
                                        // console.log(fiSplitted)
                                        fiLabel = fiSplitted.join('=')
                                    } else {
                                        quantity = fiSplitted[fiSplitted.length-1]
                                        fiSplitted.pop()
                                        fiLabel = fiSplitted.join('=')
                                        // console.log(fiLabel, record.key, record.label)
                                    }
                                }





                                // var splittedLabel = record.label.split('a');
                                // var splittedFi = splittedLabel[0].toLowerCase().split('%%c');
                                // var fi = splittedFi[1];
                                // var dist = 0
                                // if (splittedLabel.length > 1) {
                                //     dist = splittedLabel[1].split(' ');
                                //     dist = dist[0]
                                // }

                                // var longitud = record.label.split('=');
                                // longitud = longitud[longitud.length -1];




                                record.fi = fi
                                record.dist = dist
                                record.longitud = longitud
                                record.fiLabel = fiLabel
                                record.quantity = quantity

                            }

                            if (record.type == 'losaCompound') {
                                record.fi = record.text
                                record.dist = ''
                                record.longitud = ''
                                record.fiLabel = ''
                            }

                            if (record.type == 'aceroRefuerzo') {
                                if (record.key == 'L107_AR25') {
                                    console.log(record)
                                }
                                // F=F'=2%%c12|L=960
                                record.text = record.text.replaceAll('%%c', 'Φ')
                                record.text = record.text.replaceAll('%%C', 'Φ')
                                splittedLabel = record.text.split('|')
                                if (splittedLabel.length > 1) {

                                    fi = splittedLabel[0];
                                    longitud = splittedLabel[1];

                                    // console.log(longitud)
                                    if (longitud != undefined) {
                                        longitudSplitted = longitud.split('=');
                                        longitud = longitudSplitted[1];
                                    }

                                    fiSplitted = fi.split('Φ')
                                    fi = fiSplitted[1]
                                    dist = fi.split('a')
                                    if (dist.length > 1) {
                                        fi = dist[0]
                                        dist = dist[1]
                                    } else {
                                        dist = ''
                                    }
                                    fiSplitted = fiSplitted[0].split('=');

                                    quantity = 0;

                                    if (isNaN(fiSplitted[fiSplitted.length-1])) {
                                        // console.log(fiSplitted)
                                        fiLabel = fiSplitted.join('=')
                                    } else {
                                        quantity = fiSplitted[fiSplitted.length-1]
                                        fiSplitted.pop()
                                        fiLabel = fiSplitted.join('=')
                                    }
                                } else {
                                    quantity = 0
                                    fi = ''
                                    dist = ''
                                    fiLabel = record.text
                                    longitud = ''
                                }

                                record.quantity = quantity
                                record.fi = fi
                                record.dist = dist
                                record.fiLabel = fiLabel
                                record.longitud = longitud
                                record.label = record.text




                                // console.log(record.text)
                                // record.text = record.text.replace('%%c', 'Φ')
                                // record.text = record.text.replace('%%C', 'Φ')
                                // splittedLabel = record.text.split(' ')
                                // // console.log(splittedLabel)
                                // // longitud = splittedLabel[splittedLabel.length -1]
                                // // longitud = longitud.split(" ")[0]
                                // if (splittedLabel.length == 1) {
                                //     record.fi = record.text
                                //     record.fiLabel = ''
                                //     record.dist = ''
                                //     record.longitud = ''
                                //     record.fiLabel = ''
                                // } else {
                                //     record.text = record.text.replace(/\s+/g, ' ')
                                //     record.fiLabel = record.text.split('Φ')
                                //     record.fiLabel = record.fiLabel[0];
                                //     record.fi = record.fiLabel.substring(record.fiLabel.length-1, record.fiLabel.length)
                                //     // console.log(record.fi)
                                //     record.dist = record.text.split('Φ')[1].split(' ')[0]
                                //     record.longitud = record.text.split('Φ')[1].split(' ')[1].split('=')[1]
                                //     record.fiLabel = record.fiLabel.substring(0, record.fiLabel.length -2)
                                //     record.length = ''
                                // }
                            }
                        } else {
                            record.fi = 0;
                            record.dist = 0;
                            record.longitud = 0;
                        }

                    }

                    if (computingMetric.metadata == undefined) {
                        computingMetric.metadata = "";
                    }
                })

                commit('setComputingMetric',computingMetric)
            })
        },
        createComputingMetric({commit, getters}, payload) {
            commit('setComputingMetricsPagination', { page: 1, pageSize: 10, lastVisible: null, showLoadMore: true });
            commit('setComputingMetrics', []);

            let documentName = payload.documentName + '.dxf'
            let documentPath = payload.type.path

            fb.dxfFilesCollection.add({
                documentName: documentName,
                documentPath: documentPath,
                type: payload.type,
                // layerName: payload.layerName,
                status: 'Uploading',
                createdOn: fb.fromDate(new Date()),
                timestamp: fb.currentTimee(),
                createdBy: getters.userId
            }).then((docRef) => {
                console.log('Document created with ID: ' + docRef.id)
                let metadata = {
                    customMetadata: {
                        documentId: docRef.id,
                        type: payload.type.type,
                        path: payload.type.path
                    }
                }
                if (docRef.id) {
                    var storageRef = fb.storage.ref();
                    var dxfReference = storageRef.child(documentPath + documentName);
                    dxfReference.put(payload.file, metadata).then(snapshot => {
                        console.log('Uploaded a blob or file!', snapshot);
                    })
                }
            })

        },
        async fetchComputingMetricTypes({commit}) {
            await fb.computingMetricTypes.onSnapshot(querySnapshot => {
                let computingMetricTypes = []
                querySnapshot.forEach(computingMetricType => {
                    let computingMetricTypeEdited = computingMetricType.data()
                    computingMetricTypeEdited.id = computingMetricType.id
                    if (computingMetricTypeEdited.active == true) {
                        computingMetricTypes.push(computingMetricTypeEdited)
                    }
                })
                commit('setComputingMetricTypes', computingMetricTypes)
            })
        },
    }
}